const modelLightGallery = (() => {

  const pageModelroom = (document.getElementById("pageModelroom") != null);
  if (pageModelroom) {

    // console.log("object");
    let element = document.querySelector(".js-lightgallery");
    lightGallery(element, {
      download: false,
      counter: false,
      selector: '.js-item'
    });

  }

})();
export default modelLightGallery;